import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProfileService from '@/services/ProfileService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    userProfile: null,
    submitting: false,
    loading: false,
    message: '',
    errors: null,
};

export const getUserProfile = createAsyncThunk(
    'user-profile/getUserProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await ProfileService.getUserProfile();
            return response.data;
        } catch (errors) {
            return rejectWithValue(extractError(errors));
        }
    },
);

export const editUserProfile = createAsyncThunk(
    'user-profile/editUserProfile',
    async (data, { rejectWithValue }) => {
        try {
            const response = await ProfileService.editUserProfile(data);
            return response.data;
        } catch (errors) {
            return rejectWithValue(extractError(errors));
        }
    },
);

const profileSlice = createSlice({
    name: 'user-profile',
    initialState: model,
    reducers: {
        resetEditProfileSuccessMessage: (state) => {
            state.message = '';
        },
        resetEditProfileErrors: (state) => {
            state.errors = null;
        },
    },
    extraReducers: (builder) => {
        // get user profile
        builder.addCase(getUserProfile.pending, (state) => {
            state.loading = true;
            state.errors = null;
        });
        builder.addCase(getUserProfile.fulfilled, (state, action) => {
            state.loading = false;
            state.userProfile = action.payload;
        });
        builder.addCase(getUserProfile.rejected, (state, action) => {
            state.loading = false;
            state.errors = action.payload;
        });
        // edit user profile
        builder.addCase(editUserProfile.pending, (state) => {
            state.submitting = true;
            state.errors = null;
        });
        builder.addCase(editUserProfile.fulfilled, (state, action) => {
            state.submitting = false;
            state.userProfile = action.payload;
            state.message = 'Profile updated successfully!';
        });
        builder.addCase(editUserProfile.rejected, (state, action) => {
            state.submitting = false;
            state.errors = action.payload;
        });
    },
});

export const {
    resetEditProfileSuccessMessage,
    resetEditProfileErrors,
} = profileSlice.actions;

export default profileSlice.reducer;
